<div class="comments-list">
    @if (comments().length === 0) {
        <div class="empty-comment-text">No comments yet</div>
    }
    @for (comment of comments(); track comment) {
        <div #commentContainer class="comment">
            <div class="comment-header">
                <div class="layout-vbox" style="width: 100%; overflow: hidden">
                    <b class="shrinkable-block" style="flex-shrink: 1">{{comment.createdBy}}</b>
                    <span class="shrinkable-block" style="flex-shrink: 10; font-size: 10px">
                        {{AppFormat.formatAnyAsDateTime(comment.createdAt)}}
                    </span>
                </div>

                <div class="layout-hbox" style="gap: 0; white-space: nowrap;">
                    @if (comment.editMode) {
                        <fluent-button class="tiny-width" appearance="subtle" title="Save" (click)="saveEditedText(commentContainer, comment)" tabindex="-1">
                            <i class="fat fa-save"></i>
                        </fluent-button>
                        <fluent-button class="tiny-width" appearance="subtle" title="Cancel" (click)="toggleEditMode(comment)" tabindex="-1">
                            <i class="fat fa-cancel"></i>
                        </fluent-button>
                    } @else {
                        <fluent-button class="tiny-width" appearance="subtle" title="Edit" (click)="toggleEditMode(comment)" tabindex="-1"
                                       [disabled]="!canEditComment(comment)">
                            <i class="fat fa-pen"></i>
                        </fluent-button>
                    }
                    <fluent-button class="tiny-width" appearance="subtle" title="Delete" (click)="deleteCommentPopup(comment)" tabindex="-1"
                        [disabled]="!canDeleteComment(comment)">
                        <i class="fat fa-trash-xmark"></i>
                    </fluent-button>
                </div>

            </div>
            @if (comment.editMode) {
                <textarea class="comment-editor" [value]="comment.content" tabindex="-1"></textarea>
            } @else {
                <div class="comment-text markdown-output small-text" [innerHTML]="renderMarkdown(comment.content)"></div>
            }
        </div>
    }
    <div style="flex: 1;"></div>
    <div class="layout-hbox">
        <textarea #newComment class="comment-new"
                  [attr.autofocus]="autofocus()" [tabindex]="autofocus() ? 0 : -1"
                  (input)="adjustTextareaHeight(newComment)"
                  (keydown)="onCommentKeyDown($event)"
                  tabindex="-1"></textarea>
        <fluent-button class="tiny-width" appearance="subtle" title="Send" (click)="onAppendComment(newComment)" tabindex="-1"
                [disabled]="!canAddComments()">
            <i class="fat fa-send"> </i>
        </fluent-button>
    </div>
</div>
